<template>
  <div class="header flex center gaps">
    <!-- Tab -->
    <div class="tabs box grow">
      <!-- Tab > Items -->
      <el-tabs
        class="tabs_menu"
        v-model="localStatus"
        @tab-click="handleClick"
      >
        <!-- 注文済み -->
        <el-tab-pane
          label="すべて"
          name="ALL"
        />
        <el-tab-pane
          name="PROCESSING"
        >
          <div slot="label">
            新規注文
            <span class="orderCountColor">{{ processingCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="PROCESSING_CREATING_LAYOUT"
        >
          <div slot="label">
            レイアウト作成中
            <span class="orderCountColor">{{ processingCreatingLayoutCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="REVISING_LAYOUT"
        >
          <div slot="label">
            レイアウト調整
            <span class="orderCountColor">{{ revisingLayoutCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="CONFIRMED"
        >
          <div slot="label">
            注文確定
            <span class="orderCountColor">{{ confirmedCounts }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="発送済み"
          name="SHIPPED"
        />
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminHomeHeader",
  props: {
    status: String,
    orderCountByStatus: Object,
  },
  data () {
    return {
      isLoading: false,
      isLandscape: true,
    };
  },
  computed: {
    localStatus: {
      get () {
        return this.status;
      },
      set (value) {
        this.$emit("update:status", value);
      },
    },
    processingCounts () {
      const orderCounts = this.orderCountByStatus["PROCESSING"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    processingCreatingLayoutCounts () {
      const orderCounts = this.orderCountByStatus["PROCESSING_CREATING_LAYOUT"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    revisingLayoutCounts () {
      const orderCounts = this.orderCountByStatus["REVISING_LAYOUT"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
    confirmedCounts () {
      const orderCounts = this.orderCountByStatus["CONFIRMED"];
      if (!isNaN(orderCounts)) {
        return `(${orderCounts})`;
      }
      return "(0)";
    },
  },
  watch: {
  },
  created () {
  },
  methods: {
    /**
     * [handleClick description]
     * @param   {[type]}  tab  [tab description]
     * @return  {[type]}       [return description]
     */
    handleClick (tab) {
      this.$emit("onChangeStatus");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.header {
  width: 100%;
  padding: 15px 18px;
  box-sizing: border-box;

  .orderCountColor {
    color: $--color-primary;
    letter-spacing: -1px;
  }
}

::v-deep {
  .el-tabs__nav-wrap::after {
    background-color: transparent;
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__item {
    padding: 0 12px;
    font-weight: bold;
  }

  .el-tabs__active-bar {
    height: 2px;
  }

  // 注文前と注文済みの分割用
  #tab-divide1.el-tabs__item {
    padding: 0 10px;
  }
}

.orderConditionLabels {
  display: flex;
  font-size: 12.5px;

  p {
    margin: 0;
    padding-right: 134px;
  }
}

@media screen and (max-width: 820px) {
  .createButton {
    transform: scale(1.125);
    transform-origin: 80% 50%;

    .el-icon-plus {
      margin-right: 0px;
    }
  }
}

@media screen and (min-width: 821px) {
  .createButton {
    .el-icon-plus {
      margin-right: 10px;
    }
  }
}
</style>
